import { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import { IncomesProvider } from "./provider/IncomesProvider";
import IncomesSchedulePage from "./IncomesSchedulePage";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";

export const IncomesScheduleWrapper = () => {

    const incomeFilters = useSelector((state: RootState) => state.scheduler.incomeFilters);

    const defaultFilter = {
        estimated_entry_date: {
            from: incomeFilters?.estimated_entry_date.from,
            to: incomeFilters?.estimated_entry_date.to,
        },
        range_mode_view: "day",
        path: null,
    };

    return (
        <Fragment>
            <ToastContainer />
            <IncomesProvider defaultFilters={defaultFilter}>
                <IncomesSchedulePage />
            </IncomesProvider>
        </Fragment>
    );
}